<template>
  <div class="view-details-header bg-primary position-relative">
    <div class="header-overlay"></div>
    <div class="container position-relative pdt-30 pdb-30">
      <div class="d-grid-2 align-items-start justify-content-between mgt-0">
        <div class="d-flex flex-column h-full">
          <div class="t-body6 t-color-whiteHigh font-r mgb-12 h-21">
            {{ detailData.category.text }} > {{ detailData.category.child.text }}
          </div>
          <!-- <div class="t-headline11 t-color-whiteHigh font-m t-line-h-28 min-h-64"> -->
            <div class="t-headline11 t-color-whiteHigh font-m t-line-h-28 ">
            {{ title }}
          </div>
          <div class="pdt-8 pdb-10 d-flex">
            <div class="t-body6 t-color-whiteHigh font-r mgr-6 t-line-h-20">by</div>
            <div class="t-body6 t-color-whiteHigh font-r t-line-h-20">{{ lecturerName }}</div>
          </div>
          <div v-show="reviewSet.count > 0" class="d-flex align-items-center mgt-6">
            <div class="t-body1 t-color-white font-r mgr-8">{{ reviewListCount }}</div>
            <div class="d-flex">
              <i v-for="i in 5" :key="i" :class="{'selected': i < reviewSet.average + 1}" class="material-icons t-color-iconInactive mgr-1 star font-16">star</i>
            </div>
            <div class="t-body3 t-color-whiteMedium font-r mgl-8">{{ `(` + (reviewSet && reviewSet.count !== null ? reviewTotalCount : '0') + `)` }}</div>
          </div>

          <div class="mgt-11 d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center flex-wrap course-info">
              <div v-show="detailData.contentsCount.computerScience > 0" class="t-body6 t-color-whiteHigh font-r t-line-h-22 pdr-16 d-flex align-items-center mgt-11"><i class="material-icons mgr-12 t-color-iconInactive font-20 align-items-center d-flex">code</i>{{ $t('30042') }}</div>
              <div v-if="detailData.contentsCount.liveSession > 0" class="t-body6 t-color-whiteHigh font-r t-line-h-22 pdr-16 d-flex align-items-center mgt-11"><i class="material-icons mgr-12 t-color-iconInactive font-20 align-items-center d-flex">videocam</i>{{ $t('30043') }}</div>
              <div v-else class="t-body6 t-color-whiteHigh font-r t-line-h-22 pdr-16 d-flex align-items-center mgt-11"><i class="material-icons mgr-12 t-color-iconInactive font-20 align-items-center d-flex"></i></div>
             
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center mgb-30">
            <div class="d-flex align-items-center flex-wrap course-info">
             
              <div v-show="detailData.courseLanguage.length > 0" class="t-body6 t-color-whiteHigh font-r t-line-h-22 pdr-16 d-flex  mgt-11"><i class="material-icons mgr-12 t-color-iconInactive font-20 align-items-center d-flex">language</i>
                <div class="flex-grow-1">
                  <span class="pdr-4 t-nowrap">
                  {{ $t('30044') }}:
                  </span>
                  <span class="" @click="moreLanguage()" v-html="lectureLang"></span>
                </div>
              </div>
              <div v-show="detailData.subtitleLanguage.length > 0" class="t-body6 t-color-whiteHigh font-r t-line-h-22 pdr-16 d-flex  mgt-11"><i class="material-icons mgr-12 t-color-iconInactive font-20 align-items-center d-flex">subtitles</i>
                <span class="pdr-4 t-nowrap">
                  {{ $t('30045') }}:
                </span>
                <span class="" @click="moreSubtitle()" v-html="subtitleLang"></span>
              </div>
            </div>
          </div>

          <div v-if="detailData.goods" class="d-flex align-items-baseline justify-content-between mgt-24" >
						<div v-if="detailData.goods.paymentPrice > 0" class="d-flex align-items-baseline pdb-24" >
							<div class="t-body6 pdr-4 t-color-whiteHigh">{{detailData.goods.currency.key || 'USD'}}</div>
							<div class="t-headline5 pdr-8  t-color-whiteHigh font-b">{{$n(detailData.goods.paymentPrice)}}</div>
							<div v-if="detailData.goods.paymentPrice !== detailData.goods.price"  class="t-body1 t-color-whiteMedium t-line-through-red" >{{$n(detailData.goods.price)}}</div>
						</div>
						<div v-else class="d-flex align-items-baseline pdb-24" >
							<div class="t-headline5 pdr-8  t-color-whiteHigh font-b"> {{$t('664')}}</div>
						</div>
						<div class="t-body1 t-color-whiteMedium font-r">{{setRegisterRestrictText}}</div>
					</div>

          <div class="d-flex mgt-auto">
            <AppStatusBtn :degreeData="detailData" ref="applyStatusBtn" />
            <button v-if="detailData.syllabus.resourceUri" class="mdc-button t-color-secondaryBtnText mgr-8 pdl-12 pdr-12  mdc-button--outlined mgl-8 mainBtnBorder t-transform-unset" tabindex="0" @click="downloadFile(detailData.syllabus)">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label t-body2 font-r">
                {{ $t('30007') }}
              </span>
            </button>
          </div>
        </div>
        <div v-if="defaultThumbnail" class="position-relative micro-degree-card-mage-detail mgl-44
        ">
          <img :src="defaultThumbnail" alt="" class="b-radius4">
        </div>
      </div>


      
    </div>
  </div>
</template>

<script>

export default {
  name: "Header",

  components: {
    AppStatusBtn: () => import("../components/ApplyStatusBtn.vue"),
  },

  props: ['detailData', 'reviewSet'],

  data() {
    return {
      title: this.detailData.name,
      lecturerName: this.detailData.teacher.name ? this.$t('3437', {first: this.detailData.teacher.name.first, last: this.detailData.teacher.name.last}) : '',
      defaultThumbnail: this.detailData.thumbnail,
      isMoreLang: false,
      isMoreSubtitle: false,
      languageIndex: [
        'en',
        'ko',
        'zh-CN',
        'zh-TW',
        'es',
        'pt',
        'de',
        'km',
        'sw',
        'hi',
        'ar'
      ]
    }
  },

  computed: {
    reviewListCount() {
      return !this.reviewSet.average ? '0.0' : this.reviewSet.average.toFixed(1)
    },

    reviewTotalCount() {
      return this.$options.filters.digitWithComma(this.reviewSet.count);
    },

    lectureLang() {
      const { courseLanguage } = this.detailData;
      let sortedCourseLanguage = this.sortLanguage(courseLanguage);
      if(sortedCourseLanguage.length === 1) {
        return `${sortedCourseLanguage[0].text}`;
      }
      if(sortedCourseLanguage.length > 1) {
        if(this.isMoreLang) {
          return `${sortedCourseLanguage.map(item => item.text).join(", ")}`;
        }
        return `${sortedCourseLanguage[0].text}\n<span class="t-color-signBlue cursor-pointer">${this.$t('30046', {str: sortedCourseLanguage.length - 1})}</span>`;
      }
      return null;
    },

    subtitleLang() {
      const { subtitleLanguage } = this.detailData;
      let sortedSubtitleLanguage = this.sortLanguage(subtitleLanguage);
      if(sortedSubtitleLanguage.length === 1) {
        return `${sortedSubtitleLanguage[0].text}`;
      }
      if(sortedSubtitleLanguage.length > 0) {
        if(this.isMoreSubtitle) {
          return `${sortedSubtitleLanguage.map(item => item.text).join(", ")}`;
        }
        return `${sortedSubtitleLanguage[0].text}\n<span class="t-color-signBlue cursor-pointer">${this.$t('30046', {str: sortedSubtitleLanguage.length - 1})}</span>`;
      }
      return null;
    },

    // 정원 정보 노출(set register restrict)
		setRegisterRestrictText() {
			return this.detailData.capacity.registerRestrict.value === 'UNLIMITED_NUMBER' ? 
					'' :
					this.$t('605', {str1: this.detailData.capacity.learnerCount, str2: this.detailData.capacity.restrictCount})
		}
  },

  methods: {
    downloadFile(file) {
      this.$emit('downloadFile', file);
    },

    setAction(action) {
      console.log('__set Action => ', action)
    },


    sortLanguage(lang) {
      return lang.sort((a, b) => {
        const indexA = this.languageIndex.indexOf(a.value);
        const indexB = this.languageIndex.indexOf(b.value);
        if (indexA === -1 && indexB === -1) {
          return 0;
        } else if (indexA === -1) {
          return 1;
        } else if (indexB === -1) {
          return -1;
        } else {
          return indexA - indexB;
        }
      });
    },

    moreLanguage() {
      this.isMoreLang = true;
    },

    moreSubtitle() {
      this.isMoreSubtitle = true;
    },
  }
}
</script>

<style scoped>
.micro-degree-card-mage-detail img {
    width: 400px;
    height: 225px;
    object-fit: cover;
}
.font-18{
  font-size: 18px;
}
.course-info{
  max-width: 572px;
}
.course-info > div {
    min-width: 286px;
    box-sizing: border-box;
}
.min-h-64{
  min-height: 64px;
}

</style>
